import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Download } from 'lucide-react';

const GLOBAL = '__global__';

const UnitRow = ({ unit, selected, onToggle, templates, templateId, onTemplate, onDownload }) => (
  <div
    data-testid={`qr-unit-${unit.unit_id}`}
    className={`p-2 rounded-lg border-2 transition-colors ${selected ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/40'}`}
  >
    <div className="flex items-center gap-2 cursor-pointer" onClick={onToggle}>
      <Checkbox checked={selected} onClick={(e) => e.stopPropagation()} onCheckedChange={onToggle} data-testid={`qr-unit-checkbox-${unit.unit_id}`} />
      <div className="flex-1 min-w-0">
        <div className="font-medium text-sm truncate">{unit.name}</div>
        <div className="text-xs text-muted-foreground truncate">{unit.space_name}</div>
      </div>
      <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" title="Descargar QR"
        data-testid={`qr-unit-download-${unit.unit_id}`}
        onClick={(e) => { e.stopPropagation(); onDownload(unit); }}>
        <Download className="w-3 h-3" />
      </Button>
    </div>
    {selected && (
      <Select value={templateId || GLOBAL} onValueChange={(v) => onTemplate(unit.unit_id, v === GLOBAL ? null : v)}>
        <SelectTrigger className="h-8 mt-2 text-xs" data-testid={`qr-unit-template-${unit.unit_id}`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={GLOBAL}>Plantilla de la hoja</SelectItem>
          {templates.map(t => <SelectItem key={t.template_id} value={t.template_id}>{t.name}</SelectItem>)}
        </SelectContent>
      </Select>
    )}
  </div>
);

export const UnitsPanel = ({ units, spaces, filterSpace, onFilterSpace, selected, onToggle, onAll, onNone,
  templates, unitTemplates, onUnitTemplate, onDownload }) => {
  const list = filterSpace === 'all' ? units : units.filter(u => u.space_id === filterSpace);
  return (
    <Card data-testid="qr-units-panel">
      <CardHeader className="pb-3 space-y-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">Mesas / Unidades</CardTitle>
          <div className="flex gap-1">
            <Button variant="ghost" size="sm" className="text-xs h-7 px-2" onClick={() => onAll(list)} data-testid="qr-select-all">Todas</Button>
            <Button variant="ghost" size="sm" className="text-xs h-7 px-2" onClick={onNone} data-testid="qr-select-none">Ninguna</Button>
          </div>
        </div>
        <Select value={filterSpace} onValueChange={onFilterSpace}>
          <SelectTrigger data-testid="qr-space-filter"><SelectValue placeholder="Espacio" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los espacios</SelectItem>
            {spaces.map(s => <SelectItem key={s.space_id} value={s.space_id}>{s.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[420px]">
          <div className="space-y-2 pr-3">
            {list.map(u => (
              <UnitRow key={u.unit_id} unit={u} selected={selected.includes(u.unit_id)}
                onToggle={() => onToggle(u.unit_id)} templates={templates}
                templateId={unitTemplates[u.unit_id]} onTemplate={onUnitTemplate} onDownload={onDownload} />
            ))}
            {list.length === 0 && <p className="text-sm text-muted-foreground text-center py-8">No hay unidades</p>}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
